module.exports = __webpack_public_path__ + "static/media/DSCF0452.a2436471.JPG";